var appendPrependMenuMobile = function() {
        var headerLanguageCurrencyPC = $('.wrapper-language-currency'),
            headerLanguageCurrencyMB = $('.nav-currency-language'),
            headerSidebarLanguageCurrency = $('.halo-language-currency-sidebar .halo-sidebar-wrapper');
        if (window.innerWidth < 1025) {
            headerLanguageCurrencyPC.appendTo(headerLanguageCurrencyMB);
            if($('.header-nav-multi-site').hasClass('header-nav-multi-site--style_2')){
                $('.header-top--center .header__location').appendTo('.site-nav-mobile .wrapper-links');
            }
        } else {
            headerLanguageCurrencyPC.appendTo(headerSidebarLanguageCurrency);
            if($('.header-nav-multi-site').hasClass('header-nav-multi-site--style_2')){
                $('.site-nav-mobile .wrapper-links .header__location').appendTo('.header-top--wrapper .header-top--center');
            }
        };
    };
    $(document).ready(function() {
        appendPrependMenuMobile();
    });
    $(window).on('resize', function () {
        appendPrependMenuMobile();
    })